import React from 'react';
import "./ProposalPreparation.css";

const steps = [
  'Proje Fikri Analiz Ediliyor',
  'Proje Fikri Analiz Ediliyor',
  'Proje Fikri Analiz Ediliyor',
  'Proje Öneri Taslağı Hazırlanıyor',
  'Taslak İnceleniyor ve Değerlendiriliyor',
  'Proje Önerisi Geliştiriliyor',
  'Editör Düzenlemeleri Yapılıyor ve Proje Önerisi Son Haline Getiriliyor', 
  'İş Paketleri Oluşturuluyor',
  'Öncelikli Alanlar Taranıyor ve İlişkili Öncelikli Alan Tespit Ediliyor',
  'Güncel Literatür ve Yayınlar Taranıyor',
  'Güncel Literatür ve Yayınlar İnceleniyor',
  'Çıktılar Formatlanıyor' 
];

const WritingLoader = ({ currentStep }) => {
  const progress = Math.max(0, currentStep) / (steps.length - 1) * 100;

  const estimateRemainingTime = (progress) => {
    if (progress < 82) {
      // 0–40% takes 2 minutes
      return ((82 - progress) / 82 * 3 + 6); // time to 40% + 5 + 1
    } else if (progress === 82) {
      // 40–82% takes 5 minutes
      return ((82 - progress) / (82 - 40) * 5 + 1); // time to 82% + 1
    } else {
      // 82–100% takes 1 minute
      return ((100 - progress) / (100 - 82) * 1);
    }
  };

  const remainingMinutes = estimateRemainingTime(progress);

  return (
    <div>
      <div className="progress-window">
        <div className="progress-details">
          <div className="progress-text">
            <h3>{steps[currentStep]}</h3>
          </div>
          
          <p style={{ color: '#003c96', fontSize: "14px", justifySelf: "center" }}>
            Tahmini Kalan Bekleme Süresi: {remainingMinutes.toFixed(0)} dakika
          </p>

          <progress value={progress} max="100" className="progress-bar"></progress>

          <p style={{ color: '#003c96', fontSize: "16px" }}>
            %{progress.toFixed(0)} Tamamlandı
          </p>
        </div>
      </div>
    </div>
  );
};

export default WritingLoader;
